<template>
    <div class></div>
</template>

<script>
export default {
    name: 'Home',
    components: {},
    mixins: [],
    data() {
        return {}
    },
    computed: {},
    mounted() {
        const code = this.$route.query.code || ''
        const path = code ? 'login' : 'cart'
        this.$router.push({ path: `/${path}`, query: { code } })
    }
}
</script>
<style lang='stylus' scoped></style>
